import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file-upload",
  "use": "file-upload-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"file-upload\"><path d=\"M5.318 5.147L8.5 1.965l3.182 3.182s.354.354 0 .707c-.33.33-.66.04-.703.003l-.004-.003L9 3.879V12H8V3.879L6.025 5.854c0 .003-.354.353-.707 0-.354-.354 0-.707 0-.707z\" /><path d=\"M3 13h11v-2l1-1v4H2v-4l1 1v2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol